<template>
  <v-container fluid tag="section">
    <v-row class="d-flex justify-center">
      <v-col class="d-flex justify-center" md="2" cols="12">
        <v-select v-model="selectedEsercizio" @change="loadSerie()" :items="listEsercizi" item-text="season"
          item-value="annoCurEse" :menu-props="{ maxHeight: '400' }" :label="$t('accounting_exercise')" required
          color="primary" :hint="$t('pick_accounting_exercise')" persistent-hint></v-select>
      </v-col>
      <v-col class="d-flex justify-center" md="2" cols="12">
        <v-select v-model="selectedSerie" @change="loadTable()" :items="listSerie" item-text="serie" item-value="serie"
          :menu-props="{ maxHeight: '400' }" :label="$t('reg_serie')" required color="primary"
          :hint="$t('pick_reg_serie')" persistent-hint></v-select>
      </v-col>
      <v-col class="d-flex justify-center" md="2" cols="12">
        <v-btn class="mx-5" @click="renumerate" color="success">{{
          $t("renumerate_protocol")
        }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "rinumera-protocolli",
  components: {},

  data() {
    return {
      selectedEsercizio: null,
      selectedSerie: null,
      listEsercizi: [],
      listSerie: [],
    };
  },

  methods: {
    renumerate() {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        customClass: "v-application",
        showCancelButton: true,
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_renumerate"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "POST",
            "/auth/contab/renumerateProtocol/" +
            _.selectedEsercizio +
            "/" +
            _.selectedSerie,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
            }
          });
        }
      });
    },
    loadEsercizi() {
      let _ = this;
      // Recupera esercizi
      _.listEsercizi = [];
      this.chiamataAxios("GET", "auth/contab/listEsercizi").then((response) => {
        _.listEsercizi = response.data.listEsercizi;
        _.selectedEsercizio = response.data.curEsercizio.annoCurEse;
        _.loadSerie();
      });
    },
    loadSerie() {
      let _ = this;
      let url = "";
      let now = new Date();

      // Recupera esercizi
      _.listSerie = [];
      this.chiamataAxios(
        "GET",
        "auth/contab/listSerie/" + _.selectedEsercizio
      ).then((response) => {
        _.listSerie = response.data;
        if (_.listSerie.length >= 1) _.selectedSerie = _.listSerie[0].serie;
      });
    },
  },
  created() {
    this.loadEsercizi();
  },
};
</script>